import React from 'react';
import { Content_File, PlayerIncomingChatBubbleFragment } from '../../../../generated/spin-graphql';
import { PictureWithFallback } from '../../../sections/PictureWithFallback';
import { MessageContainer } from '../MessageContainer';
import { gql } from '@urql/core';

type Props = {
    picture?: Partial<Content_File>;
    message: PlayerIncomingChatBubbleFragment;
};

gql`
    fragment PlayerIncomingChatBubble on espin_message {
        ...MessageContainer
        college {
            name
        }
    }
`;

export const PlayerIncomingChatBubble: React.FC<Props> = ({ picture, message }) => {
    const author = message.college?.name;
    return (
        <div className="chat-bubble">
            <div className="image-wrapper">
                <PictureWithFallback width={40} height={40} icon={picture} alt={`${author}'s profile image`} />
            </div>
            <MessageContainer message={message} />
        </div>
    );
};
